import clsx from "clsx";

import "@src/components/Button/style.less";
import "./style.less";

// Link "Voltar" para a tela de Login (/). Usa <a> (navegação real) em vez de
// <button>, reaproveitando o visual de .Button-component.
export function LoginButton({ className }: { className?: string }) {
  return (
    <a
      href="/"
      className={clsx("Button-component", "LoginButton-component", className)}
    >
      Voltar
    </a>
  );
}
